module.exports = __webpack_public_path__ + "static/media/11.0d2cbd28.gif";